export const ehrPlatformData = {
  data: [
    {
      id: 1,
      name: 'Advanced Health',
      description: null,
      sourceId: null,
      destinationId: null,
      createdAt: '2019-09-09T20:47:40.402Z',
      updatedAt: '2019-09-09T20:47:40.402Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 2,
      name: 'Athena',
      description: null,
      sourceId: null,
      destinationId: null,
      createdAt: '2019-09-09T20:47:40.401Z',
      updatedAt: '2019-09-09T20:47:40.401Z',
      createdBy: null,
      updatedBy: null,
    },
  ],
  limit: 2,
  skip: 0,
  total: 2,
};
